export const COUNTRY_ISO_MAP = {
  Afghanistan: "AF",
  Albania: "AL",
  Algeria: "DZ",
  Andorra: "AD",
  Angola: "AO",
  Anguilla: "AI",
  "Antigua and Barbuda": "AG",
  Argentina: "AR",
  Armenia: "AM",
  Aruba: "AW",
  Australia: "AU",
  Austria: "AT",
  Azerbaijan: "AZ",
  Bahrain: "BH",
  Belarus: "BY",
  Belgium: "BE",
  Bermuda: "BM",
  Benin: "BJ",
  "Bosnia and Herzegovina": "BA",
  Botswana: "BW",
  Brazil: "BR",
  Brunei: "BN",
  Bulgaria: "BG",
  "Burkina Faso": "BF",
  Burundi: "BI",
  Cambodia: "KH",
  Cameroon: "CM",
  Canada: "CA",
  "Cape Verde": "CV",
  "Central African Republic": "CF",
  Chad: "TD",
  Chile: "CL",
  China: "CN",
  Colombia: "CO",
  Comoros: "KM",
  Congo: "CG",
  Croatia: "HR",
  Cyprus: "CY",
  "Czech Republic": "CZ",
  Denmark: "DK",
  Djibouti: "DJ",
  Egypt: "EG",
  "Equatorial Guinea": "GQ",
  Eritrea: "ER",
  Estonia: "EE",
  Ethiopia: "ET",
  "Faroe Islands": "FO",
  Finland: "FI",
  France: "FR",
  Gabon: "GA",
  Gambia: "GM",
  Georgia: "GE",
  Germany: "DE",
  Ghana: "GH",
  Gibraltar: "GI",
  Greece: "GR",
  Greenland: "GL",
  Guernsey: "GG",
  Guinea: "GN",
  "Guinea-Bissau": "GW",
  Hungary: "HU",
  Iceland: "IS",
  India: "IN",
  Indonesia: "ID",
  Iran: "IR",
  Iraq: "IQ",
  Ireland: "IE",
  "Isle of Man": "IM",
  Israel: "IL",
  Italy: "IT",
  "Ivory Coast": "CI",
  Japan: "JP",
  Jersey: "JE",
  Jordan: "JO",
  Kazakhstan: "KZ",
  Kenya: "KE",
  Kosovo: "XK",
  Kuwait: "KW",
  Kyrgyzstan: "KG",
  Laos: "LA",
  Latvia: "LV",
  Lebanon: "LB",
  Lesotho: "LS",
  Liberia: "LR",
  Libya: "LY",
  Liechtenstein: "LI",
  Lithuania: "LT",
  Luxembourg: "LU",
  Macau: "MO",
  Macedonia: "MK",
  Madagascar: "MG",
  Malawi: "MW",
  Malaysia: "MY",
  Maldives: "MV",
  Mali: "ML",
  Malta: "MT",
  "Marshall Islands": "MH",
  Mauritania: "MR",
  Mauritius: "MU",
  Mayotte: "YT",
  Mexico: "MX",
  Moldova: "MD",
  Monaco: "MC",
  Mongolia: "MN",
  Montenegro: "ME",
  Morocco: "MA",
  Mozambique: "MZ",
  Myanmar: "MM",
  Namibia: "NA",
  Nauru: "NR",
  Nepal: "NP",
  Netherlands: "NL",
  "New Caledonia": "NC",
  "New Zealand": "NZ",
  Niger: "NE",
  Nigeria: "NG",
  Niue: "NU",
  "Norfolk Island": "NF",
  "North Korea": "KP",
  "Northern Mariana Islands": "MP",
  Norway: "NO",
  Oman: "OM",
  Pakistan: "PK",
  Palau: "PW",
  "Papua New Guinea": "PG",
  Philippines: "PH",
  Pitcairn: "PN",
  Poland: "PL",
  Portugal: "PT",
  Qatar: "QA",
  Romania: "RO",
  Russia: "RU",
  Rwanda: "RW",
  Réunion: "RE",
  "Saint Pierre and Miquelon": "PM",
  Samoa: "WS",
  "San Marino": "SM",
  "Sao Tome and Principe": "ST",
  "Saudi Arabia": "SA",
  Senegal: "SN",
  Serbia: "RS",
  Seychelles: "SC",
  "Sierra Leone": "SL",
  Singapore: "SG",
  Slovakia: "SK",
  Slovenia: "SI",
  "Solomon Islands": "SB",
  Somalia: "SO",
  "South Africa": "ZA",
  "South Korea": "KR",
  Spain: "ES",
  "Sri Lanka": "LK",
  Sudan: "SD",
  Suriname: "SR",
  Swaziland: "SZ",
  Sweden: "SE",
  Switzerland: "CH",
  Syria: "SY",
  Taiwan: "TW",
  Tajikistan: "TJ",
  Tanzania: "TZ",
  Thailand: "TH",
  "Timor-Leste": "TL",
  Togo: "TG",
  Tokelau: "TK",
  Tonga: "TO",
  Tunisia: "TN",
  Turkey: "TR",
  Turkmenistan: "TM",
  Uganda: "UG",
  Ukraine: "UA",
  "United Arab Emirates": "AE",
  "United Kingdom": "GB",
  USA: "US",
  Uzbekistan: "UZ",
  Vanuatu: "VU",
  "Vatican City State (Holy See)": "VA",
  Vietnam: "VN",
  "Wallis and Futuna": "WF",
  Yemen: "YE",
  Zambia: "ZM",
  Zimbabwe: "ZW",
  "South Georgia and the South Sandwich Islands": "GS",
  Bahamas: "BS",
  Barbados: "BB",
  Belize: "BZ",
  Bolivia: "BO",
  "Cayman Islands": "KY",
  "Costa Rica": "CR",
  Cuba: "CU",
  Dominica: "DM",
  "Dominican Republic": "DO",
  Ecuador: "EC",
  "El Salvador": "SV",
  "Falkland Islands": "FK",
  Grenada: "GD",
  Guadeloupe: "GP",
  Guatemala: "GT",
  Guyana: "GY",
  Haiti: "HT",
  Honduras: "HN",
  Jamaica: "JM",
  Martinique: "MQ",
  Montserrat: "MS",
  Nicaragua: "NI",
  Panama: "PA",
  Paraguay: "PY",
  Peru: "PE",
  "Puerto Rico": "PR",
  "Saint Kitts and Nevis": "KN",
  "Saint Lucia": "LC",
  "Saint Vincent and the Grenadines": "VC",
  "Trinidad and Tobago": "TT",
  "Turks and Caicos Islands": "TC",
  Uruguay: "UY",
  Venezuela: "VE",
  Bangladesh: "BD",
  Bhutan: "BT",
  "British Indian Ocean Territory": "IO",
  "Christmas Island": "CX",
  "Cocos (Keeling) Islands": "CC",
  "Cook Islands": "CK",
  Fiji: "FJ",
  "French Polynesia": "PF",
  Guam: "GU",
  "Heard Island and McDonald Islands": "HM",
  "Hong Kong": "HK",
  Kiribati: "KI",
  Afghanistan: "AF",
  Taiwan: "TW",
  Japan: "JP",
  "South Korea": "KR",
  "Ivory Coast": "CI",
  Kosovo: "XK",
};

export const translateCountry = (countryName, language) => {
  if (!countryName || !language || language === "en") return countryName;
  const isoCode = COUNTRY_ISO_MAP[countryName];
  if (!isoCode) return countryName;
  try {
    const displayNames = new Intl.DisplayNames([language], { type: "region" });
    return displayNames.of(isoCode) || countryName;
  } catch {
    return countryName;
  }
};

export const COUNTRY_NAME_MAP = {
  Singapore: {
    de: "Singapur",
    it: "Singapore",
    ja: "シンガポール",
    ko: "싱가포르",
    th: "สิงคโปร์",
    "zh-CN": "新加坡",
    "zh-TW": "新加坡",
  },
  Thailand: {
    de: "Thailand",
    it: "Tailandia",
    ja: "タイ",
    ko: "태국",
    th: "ไทย",
    "zh-CN": "泰国",
    "zh-TW": "泰國",
  },
  Malaysia: {
    de: "Malaysia",
    it: "Malaysia",
    ja: "マレーシア",
    ko: "말레이시아",
    th: "มาเลเซีย",
    "zh-CN": "马来西亚",
    "zh-TW": "馬來西亞",
  },
  Indonesia: {
    de: "Indonesien",
    it: "Indonesia",
    ja: "インドネシア",
    ko: "인도네시아",
    th: "อินโดนีเซีย",
    "zh-CN": "印度尼西亚",
    "zh-TW": "印度尼西亞",
  },
  Myanmar: {
    de: "Myanmar",
    it: "Myanmar",
    ja: "ミャンマー",
    ko: "미얀마",
    th: "เมียนมา",
    "zh-CN": "缅甸",
    "zh-TW": "緬甸",
  },
  China: {
    de: "China",
    it: "Cina",
    ja: "中国",
    ko: "중국",
    th: "จีน",
    "zh-CN": "中国",
    "zh-TW": "中國",
  },
  Vietnam: {
    de: "Vietnam",
    it: "Vietnam",
    ja: "ベトナム",
    ko: "베트남",
    th: "เวียดนาม",
    "zh-CN": "越南",
    "zh-TW": "越南",
  },
  Philippines: {
    de: "Philippinen",
    it: "Filippine",
    ja: "フィリピン",
    ko: "필리핀",
    th: "ฟิลิปปินส์",
    "zh-CN": "菲律宾",
    "zh-TW": "菲律賓",
  },
  USA: {
    de: "USA",
    it: "USA",
    ja: "アメリカ",
    ko: "미국",
    th: "สหรัฐอเมริกา",
    "zh-CN": "美国",
    "zh-TW": "美國",
  },
  Brazil: {
    de: "Brasilien",
    it: "Brasile",
    ja: "ブラジル",
    ko: "브라질",
    th: "บราซิล",
    "zh-CN": "巴西",
    "zh-TW": "巴西",
  },
  India: {
    de: "Indien",
    it: "India",
    ja: "インド",
    ko: "인도",
    th: "อินเดีย",
    "zh-CN": "印度",
    "zh-TW": "印度",
  },
  Mongolia: {
    de: "Mongolei",
    it: "Mongolia",
    ja: "モンゴル",
    ko: "몽골",
    th: "มองโกเลีย",
    "zh-CN": "蒙古",
    "zh-TW": "蒙古",
  },
  "Saudi Arabia": {
    de: "Saudi-Arabien",
    it: "Arabia Saudita",
    ja: "サウジアラビア",
    ko: "사우디아라비아",
    th: "ซาอุดีอาระเบีย",
    "zh-CN": "沙特阿拉伯",
    "zh-TW": "沙烏地阿拉伯",
  },
  Germany: {
    de: "Deutschland",
    it: "Germania",
    ja: "ドイツ",
    ko: "독일",
    th: "เยอรมนี",
    "zh-CN": "德国",
    "zh-TW": "德國",
  },
  "United Arab Emirates": {
    de: "Vereinigte Arabische Emirate",
    it: "Emirati Arabi Uniti",
    ja: "アラブ首長国連邦",
    ko: "아랍에미리트",
    th: "สหรัฐอาหรับเอมิเรตส์",
    "zh-CN": "阿联酋",
    "zh-TW": "阿聯酋",
  },
  Australia: {
    de: "Australien",
    it: "Australia",
    ja: "オーストラリア",
    ko: "호주",
    th: "ออสเตรเลีย",
    "zh-CN": "澳大利亚",
    "zh-TW": "澳大利亞",
  },
};

export const OBJECTIVE_NAME_MAP = {
  Electricity: {
    de: "Strom",
    it: "Elettricità",
    ja: "電力",
    ko: "전기",
    th: "ไฟฟ้า",
    "zh-CN": "电力",
    "zh-TW": "電力",
  },
  Heating: {
    de: "Heizung",
    it: "Riscaldamento",
    ja: "暖房",
    ko: "난방",
    th: "ระบบทำความร้อน",
    "zh-CN": "供热",
    "zh-TW": "供熱",
  },
  Cooling: {
    de: "Kühlung",
    it: "Raffreddamento",
    ja: "冷却",
    ko: "냉방",
    th: "ระบบทำความเย็น",
    "zh-CN": "冷却",
    "zh-TW": "冷卻",
  },
  Fuel: {
    de: "Kraftstoff",
    it: "Carburante",
    ja: "燃料",
    ko: "연료",
    th: "เชื้อเพลิง",
    "zh-CN": "燃料",
    "zh-TW": "燃料",
  },
  Water: {
    de: "Wasser",
    it: "Acqua",
    ja: "水",
    ko: "물",
    th: "น้ำ",
    "zh-CN": "水",
    "zh-TW": "水",
  },
};

export const COUNTRY_VALUE_MAP = {
  Singapore: {
    de: "Singapur",
    it: "Singapore",
    ja: "シンガポール",
    ko: "싱가포르",
    th: "สิงคโปร์",
    "zh-CN": "新加坡",
    "zh-TW": "新加坡",
  },
};

export const INDUSTRY_VALUE_MAP = {
  Others: {
    de: "Sonstige",
    it: "Altri",
    ja: "その他",
    ko: "기타",
    th: "อื่นๆ",
    "zh-CN": "其他",
    "zh-TW": "其他",
  },
  "Food - 081 Processing and Preserving of Meat": {
    de: "Lebensmittel - 081 Verarbeitung und Konservierung von Fleisch",
    it: "Alimentare - 081 Lavorazione e conservazione della carne",
    ja: "食品 - 081 肉の加工・保存",
    ko: "식품 - 081 육류 가공 및 보존",
    th: "อาหาร - 081 การแปรรูปและถนอมเนื้อสัตว์",
    "zh-CN": "食品 - 081 肉类加工与保存",
    "zh-TW": "食品 - 081 肉類加工與保存",
  },
  "Food - 082 Processing and Preserving of Fish, Crustaceans and Molluscs": {
    de: "Lebensmittel - 082 Verarbeitung und Konservierung von Fisch",
    it: "Alimentare - 082 Lavorazione e conservazione di pesci e molluschi",
    ja: "食品 - 082 魚・甲殻類・軟体動物の加工・保存",
    ko: "식품 - 082 어류, 갑각류 및 연체동물 가공 및 보존",
    th: "อาหาร - 082 การแปรรูปและถนอมปลา กุ้ง และหอย",
    "zh-CN": "食品 - 082 鱼类、甲壳类和软体动物加工与保存",
    "zh-TW": "食品 - 082 魚類、甲殼類和軟體動物加工與保存",
  },
  "Food - 083 Processing and Preserving of Fruit and Vegetables": {
    de: "Lebensmittel - 083 Verarbeitung und Konservierung von Obst und Gemüse",
    it: "Alimentare - 083 Lavorazione e conservazione di frutta e verdura",
    ja: "食品 - 083 果物・野菜の加工・保存",
    ko: "식품 - 083 과일 및 채소 가공 및 보존",
    th: "อาหาร - 083 การแปรรูปและถนอมผลไม้และผัก",
    "zh-CN": "食品 - 083 水果和蔬菜加工与保存",
    "zh-TW": "食品 - 083 水果和蔬菜加工與保存",
  },
  "Food - 084 Manufacture of Edible Vegetable and Animal Oils and Fats": {
    de: "Lebensmittel - 084 Herstellung von Speiseölen und -fetten",
    it: "Alimentare - 084 Produzione di oli e grassi vegetali e animali commestibili",
    ja: "食品 - 084 食用植物油・動物油脂の製造",
    ko: "식품 - 084 식용 식물성 및 동물성 유지 제조",
    th: "อาหาร - 084 การผลิตน้ำมันพืชและไขมันสัตว์ที่รับประทานได้",
    "zh-CN": "食品 - 084 食用植物油和动物油脂制造",
    "zh-TW": "食品 - 084 食用植物油和動物油脂製造",
  },
  "Food - 085 Manufacture of Dairy Products": {
    de: "Lebensmittel - 085 Herstellung von Milchprodukten",
    it: "Alimentare - 085 Produzione di latticini",
    ja: "食品 - 085 乳製品の製造",
    ko: "식품 - 085 유제품 제조",
    th: "อาหาร - 085 การผลิตผลิตภัณฑ์นม",
    "zh-CN": "食品 - 085 乳制品制造",
    "zh-TW": "食品 - 085 乳製品製造",
  },
  "Food - 086 Grain Husking, Manufacture of Grain Mill Products, Starches and Starch Products":
    {
      de: "Lebensmittel - 086 Getreideenthülsung, Herstellung von Getreidemahlprodukten",
      it: "Alimentare - 086 Sbucciatura dei cereali, produzione di farine e amidi",
      ja: "食品 - 086 穀物精製・製粉製品・でんぷんの製造",
      ko: "식품 - 086 곡물 도정, 제분 제품, 전분 제조",
      th: "อาหาร - 086 การสีเมล็ดธัญพืช การผลิตผลิตภัณฑ์แป้งและแป้งมัน",
      "zh-CN": "食品 - 086 谷物碾磨、制粉产品及淀粉制造",
      "zh-TW": "食品 - 086 穀物碾磨、製粉產品及澱粉製造",
    },
  "Food - 087 Manufacture of Prepared Animal Feeds": {
    de: "Lebensmittel - 087 Herstellung von Tierfutter",
    it: "Alimentare - 087 Produzione di mangimi preparati per animali",
    ja: "食品 - 087 調製飼料の製造",
    ko: "식품 - 087 조제 동물 사료 제조",
    th: "อาหาร - 087 การผลิตอาหารสัตว์สำเร็จรูป",
    "zh-CN": "食品 - 087 配制动物饲料制造",
    "zh-TW": "食品 - 087 配製動物飼料製造",
  },
  "Food - 089 Manufacture of Other Food Products": {
    de: "Lebensmittel - 089 Herstellung sonstiger Nahrungsmittel",
    it: "Alimentare - 089 Produzione di altri prodotti alimentari",
    ja: "食品 - 089 その他の食品の製造",
    ko: "식품 - 089 기타 식품 제조",
    th: "อาหาร - 089 การผลิตผลิตภัณฑ์อาหารอื่นๆ",
    "zh-CN": "食品 - 089 其他食品制造",
    "zh-TW": "食品 - 089 其他食品製造",
  },
  "Beverages - 091 Manufacture of Alcoholic Beverages": {
    de: "Getränke - 091 Herstellung alkoholischer Getränke",
    it: "Bevande - 091 Produzione di bevande alcoliche",
    ja: "飲料 - 091 アルコール飲料の製造",
    ko: "음료 - 091 알코올 음료 제조",
    th: "เครื่องดื่ม - 091 การผลิตเครื่องดื่มแอลกอฮอล์",
    "zh-CN": "饮料 - 091 酒精饮料制造",
    "zh-TW": "飲料 - 091 酒精飲料製造",
  },
  "Beverages - 092 Manufacture of Non-alcoholic Beverages": {
    de: "Getränke - 092 Herstellung alkoholfreier Getränke",
    it: "Bevande - 092 Produzione di bevande analcoliche",
    ja: "飲料 - 092 非アルコール飲料の製造",
    ko: "음료 - 092 비알코올 음료 제조",
    th: "เครื่องดื่ม - 092 การผลิตเครื่องดื่มไม่มีแอลกอฮอล์",
    "zh-CN": "饮料 - 092 非酒精饮料制造",
    "zh-TW": "飲料 - 092 非酒精飲料製造",
  },
  "Tobacco - 100 Manufacture of Tobacco Products": {
    de: "Tabak - 100 Herstellung von Tabakerzeugnissen",
    it: "Tabacco - 100 Produzione di prodotti del tabacco",
    ja: "タバコ - 100 タバコ製品の製造",
    ko: "담배 - 100 담배 제품 제조",
    th: "ยาสูบ - 100 การผลิตผลิตภัณฑ์ยาสูบ",
    "zh-CN": "烟草 - 100 烟草产品制造",
    "zh-TW": "菸草 - 100 菸草產品製造",
  },
  "Apparel & Textiles - 111 Spinning of Yarn": {
    de: "Bekleidung & Textilien - 111 Garnspinnen",
    it: "Abbigliamento e tessuti - 111 Filatura di filati",
    ja: "アパレル・繊維 - 111 糸紡績",
    ko: "의류 및 섬유 - 111 방적",
    th: "เครื่องนุ่งห่มและสิ่งทอ - 111 การปั่นด้าย",
    "zh-CN": "服装与纺织 - 111 纺纱",
    "zh-TW": "服裝與紡織 - 111 紡紗",
  },
  "Apparel & Textiles - 112 Weaving of Textiles": {
    de: "Bekleidung & Textilien - 112 Textilweberei",
    it: "Abbigliamento e tessuti - 112 Tessitura di tessuti",
    ja: "アパレル・繊維 - 112 織物",
    ko: "의류 및 섬유 - 112 직물 제직",
    th: "เครื่องนุ่งห่มและสิ่งทอ - 112 การทอผ้า",
    "zh-CN": "服装与纺织 - 112 纺织品织造",
    "zh-TW": "服裝與紡織 - 112 紡織品織造",
  },
  "Apparel & Textiles - 113 Manufacture of Non-woven Fabrics": {
    de: "Bekleidung & Textilien - 113 Herstellung von Vliesstoffen",
    it: "Abbigliamento e tessuti - 113 Produzione di tessuti non tessuti",
    ja: "アパレル・繊維 - 113 不織布の製造",
    ko: "의류 및 섬유 - 113 부직포 제조",
    th: "เครื่องนุ่งห่มและสิ่งทอ - 113 การผลิตผ้าใยสังเคราะห์",
    "zh-CN": "服装与纺织 - 113 无纺布制造",
    "zh-TW": "服裝與紡織 - 113 無紡布製造",
  },
  "Apparel & Textiles - 114 Finishing of Textiles": {
    de: "Bekleidung & Textilien - 114 Textilveredelung",
    it: "Abbigliamento e tessuti - 114 Rifinitura dei tessuti",
    ja: "アパレル・繊維 - 114 繊維の仕上げ加工",
    ko: "의류 및 섬유 - 114 섬유 마감 처리",
    th: "เครื่องนุ่งห่มและสิ่งทอ - 114 การตกแต่งสิ่งทอ",
    "zh-CN": "服装与纺织 - 114 纺织品整理",
    "zh-TW": "服裝與紡織 - 114 紡織品整理",
  },
  "Apparel & Textiles - 115 Manufacture of Textile Products": {
    de: "Bekleidung & Textilien - 115 Herstellung von Textilprodukten",
    it: "Abbigliamento e tessuti - 115 Produzione di prodotti tessili",
    ja: "アパレル・繊維 - 115 繊維製品の製造",
    ko: "의류 및 섬유 - 115 섬유 제품 제조",
    th: "เครื่องนุ่งห่มและสิ่งทอ - 115 การผลิตผลิตภัณฑ์สิ่งทอ",
    "zh-CN": "服装与纺织 - 115 纺织品制造",
    "zh-TW": "服裝與紡織 - 115 紡織品製造",
  },
  "Apparel & Textiles - 121 Manufacture of Wearing Apparel": {
    de: "Bekleidung & Textilien - 121 Herstellung von Bekleidung",
    it: "Abbigliamento e tessuti - 121 Produzione di abbigliamento",
    ja: "アパレル・繊維 - 121 衣服の製造",
    ko: "의류 및 섬유 - 121 의류 제조",
    th: "เครื่องนุ่งห่มและสิ่งทอ - 121 การผลิตเครื่องนุ่งห่ม",
    "zh-CN": "服装与纺织 - 121 服装制造",
    "zh-TW": "服裝與紡織 - 121 服裝製造",
  },
  "Apparel & Textiles - 123 Manufacture of Clothing Accessories": {
    de: "Bekleidung & Textilien - 123 Herstellung von Bekleidungszubehör",
    it: "Abbigliamento e tessuti - 123 Produzione di accessori per abbigliamento",
    ja: "アパレル・繊維 - 123 衣料品アクセサリーの製造",
    ko: "의류 및 섬유 - 123 의류 액세서리 제조",
    th: "เครื่องนุ่งห่มและสิ่งทอ - 123 การผลิตอุปกรณ์เครื่องแต่งกาย",
    "zh-CN": "服装与纺织 - 123 服装配件制造",
    "zh-TW": "服裝與紡織 - 123 服裝配件製造",
  },
  "Consumer Goods Retail - 130 Manufacture of Leather, Fur and Related Products":
    {
      de: "Konsumgüterhandel - 130 Herstellung von Leder- und Pelzprodukten",
      it: "Beni di consumo - 130 Produzione di pelle, pellicce e prodotti correlati",
      ja: "消費財小売 - 130 皮革・毛皮製品の製造",
      ko: "소비재 소매 - 130 가죽, 모피 및 관련 제품 제조",
      th: "สินค้าอุปโภคบริโภค - 130 การผลิตหนัง ขนสัตว์ และผลิตภัณฑ์ที่เกี่ยวข้อง",
      "zh-CN": "消费品零售 - 130 皮革、毛皮及相关产品制造",
      "zh-TW": "消費品零售 - 130 皮革、毛皮及相關產品製造",
    },
  "Forestry & Paper - 140 Manufacture of Wood and of Products of Wood and Bamboo":
    {
      de: "Forstwirtschaft & Papier - 140 Holz- und Bambusprodukte",
      it: "Silvicoltura e carta - 140 Produzione di legno e prodotti in legno e bambù",
      ja: "林業・紙 - 140 木材・竹製品の製造",
      ko: "임업 및 제지 - 140 목재 및 목재·대나무 제품 제조",
      th: "ป่าไม้และกระดาษ - 140 การผลิตไม้และผลิตภัณฑ์จากไม้และไม้ไผ่",
      "zh-CN": "林业与造纸 - 140 木材及竹制品制造",
      "zh-TW": "林業與造紙 - 140 木材及竹製品製造",
    },
  "Forestry & Paper - 151 Manufacture of Pulp, Paper and Paperboard": {
    de: "Forstwirtschaft & Papier - 151 Herstellung von Zellstoff, Papier und Pappe",
    it: "Silvicoltura e carta - 151 Produzione di pasta, carta e cartone",
    ja: "林業・紙 - 151 パルプ・紙・板紙の製造",
    ko: "임업 및 제지 - 151 펄프, 종이 및 판지 제조",
    th: "ป่าไม้และกระดาษ - 151 การผลิตเยื่อกระดาษ กระดาษ และกระดาษแข็ง",
    "zh-CN": "林业与造纸 - 151 纸浆、纸及纸板制造",
    "zh-TW": "林業與造紙 - 151 紙漿、紙及紙板製造",
  },
  "Semicon - 261 Manufacture of Semi-conductors": {
    de: "Halbleiter - 261 Herstellung von Halbleitern",
    it: "Semiconduttori - 261 Produzione di semiconduttori",
    ja: "半導体 - 261 半導体の製造",
    ko: "반도체 - 261 반도체 제조",
    th: "เซมิคอนดักเตอร์ - 261 การผลิตเซมิคอนดักเตอร์",
    "zh-CN": "半导体 - 261 半导体制造",
    "zh-TW": "半導體 - 261 半導體製造",
  },
  "Semicon - 262 Manufacture of Electronic Passive Devices": {
    de: "Halbleiter - 262 Herstellung elektronischer Passivbauelemente",
    it: "Semiconduttori - 262 Produzione di dispositivi elettronici passivi",
    ja: "半導体 - 262 電子受動部品の製造",
    ko: "반도체 - 262 전자 수동 소자 제조",
    th: "เซมิคอนดักเตอร์ - 262 การผลิตอุปกรณ์อิเล็กทรอนิกส์แบบพาสซีฟ",
    "zh-CN": "半导体 - 262 电子无源器件制造",
    "zh-TW": "半導體 - 262 電子無源器件製造",
  },
  "Semicon - 263 Manufacture of Bare Printed Circuit Boards": {
    de: "Halbleiter - 263 Herstellung von nackten Leiterplatten",
    it: "Semiconduttori - 263 Produzione di circuiti stampati nudi",
    ja: "半導体 - 263 裸のプリント基板の製造",
    ko: "반도체 - 263 나형 인쇄 회로 기판 제조",
    th: "เซมิคอนดักเตอร์ - 263 การผลิตแผงวงจรพิมพ์เปล่า",
    "zh-CN": "半导体 - 263 裸印刷电路板制造",
    "zh-TW": "半導體 - 263 裸印刷電路板製造",
  },
  "Semicon - 264 Manufacture of Optoelectronic Materials and Components": {
    de: "Halbleiter - 264 Herstellung optoelektronischer Materialien",
    it: "Semiconduttori - 264 Produzione di materiali e componenti optoelettronici",
    ja: "半導体 - 264 光電子材料・部品の製造",
    ko: "반도체 - 264 광전자 재료 및 부품 제조",
    th: "เซมิคอนดักเตอร์ - 264 การผลิตวัสดุและส่วนประกอบออปโตอิเล็กทรอนิกส์",
    "zh-CN": "半导体 - 264 光电子材料和元件制造",
    "zh-TW": "半導體 - 264 光電子材料和元件製造",
  },
  "Semicon - 269 Manufacture of Other Electronic Parts and Components": {
    de: "Halbleiter - 269 Herstellung sonstiger elektronischer Bauteile",
    it: "Semiconduttori - 269 Produzione di altri componenti elettronici",
    ja: "半導体 - 269 その他の電子部品の製造",
    ko: "반도체 - 269 기타 전자 부품 제조",
    th: "เซมิคอนดักเตอร์ - 269 การผลิตชิ้นส่วนและส่วนประกอบอิเล็กทรอนิกส์อื่นๆ",
    "zh-CN": "半导体 - 269 其他电子零部件制造",
    "zh-TW": "半導體 - 269 其他電子零部件製造",
  },
  "Technology - 271 Manufacture of Computers and Peripheral Equipment": {
    de: "Technologie - 271 Herstellung von Computern und Peripheriegeräten",
    it: "Tecnologia - 271 Produzione di computer e apparecchiature periferiche",
    ja: "テクノロジー - 271 コンピュータ・周辺機器の製造",
    ko: "기술 - 271 컴퓨터 및 주변 장치 제조",
    th: "เทคโนโลยี - 271 การผลิตคอมพิวเตอร์และอุปกรณ์ต่อพ่วง",
    "zh-CN": "技术 - 271 计算机和外围设备制造",
    "zh-TW": "技術 - 271 計算機和外圍設備製造",
  },
  "Technology - 272 Manufacture of Communication Equipment": {
    de: "Technologie - 272 Herstellung von Kommunikationsgeräten",
    it: "Tecnologia - 272 Produzione di apparecchiature per comunicazioni",
    ja: "テクノロジー - 272 通信機器の製造",
    ko: "기술 - 272 통신 장비 제조",
    th: "เทคโนโลยี - 272 การผลิตอุปกรณ์สื่อสาร",
    "zh-CN": "技术 - 272 通信设备制造",
    "zh-TW": "技術 - 272 通信設備製造",
  },
  "Technology - 273 Manufacture of Audio and Video Equipment": {
    de: "Technologie - 273 Herstellung von Audio- und Videogeräten",
    it: "Tecnologia - 273 Produzione di apparecchiature audio e video",
    ja: "テクノロジー - 273 音響・映像機器の製造",
    ko: "기술 - 273 오디오 및 비디오 장비 제조",
    th: "เทคโนโลยี - 273 การผลิตอุปกรณ์เสียงและวิดีโอ",
    "zh-CN": "技术 - 273 音视频设备制造",
    "zh-TW": "技術 - 273 音視頻設備製造",
  },
  "Technology - 274 Manufacture of Magnetic and Optical Media": {
    de: "Technologie - 274 Herstellung von Magnet- und optischen Medien",
    it: "Tecnologia - 274 Produzione di supporti magnetici e ottici",
    ja: "テクノロジー - 274 磁気・光学メディアの製造",
    ko: "기술 - 274 자기 및 광학 미디어 제조",
    th: "เทคโนโลยี - 274 การผลิตสื่อแม่เหล็กและออปติคัล",
    "zh-CN": "技术 - 274 磁性和光学媒体制造",
    "zh-TW": "技術 - 274 磁性和光學媒體製造",
  },
  "Technology - 275 Manufacture of Measuring, Navigating, Control Equipment, Watches and Clocks":
    {
      de: "Technologie - 275 Herstellung von Mess-, Navigations- und Steuerungsgeräten",
      it: "Tecnologia - 275 Produzione di strumenti di misurazione, navigazione e controllo",
      ja: "テクノロジー - 275 計測・航法・制御機器・時計の製造",
      ko: "기술 - 275 측정, 항법, 제어 장비, 시계 제조",
      th: "เทคโนโลยี - 275 การผลิตอุปกรณ์วัด นำทาง ควบคุม และนาฬิกา",
      "zh-CN": "技术 - 275 测量、导航、控制设备及钟表制造",
      "zh-TW": "技術 - 275 測量、導航、控制設備及鐘錶製造",
    },
  "Technology - 276 Manufacture of Irradiation and Electromedical Equipment": {
    de: "Technologie - 276 Herstellung von Bestrahlungs- und elektromedizinischen Geräten",
    it: "Tecnologia - 276 Produzione di apparecchiature di irradiazione ed elettromedicali",
    ja: "テクノロジー - 276 放射線・電気医療機器の製造",
    ko: "기술 - 276 방사선 및 전기 의료 장비 제조",
    th: "เทคโนโลยี - 276 การผลิตอุปกรณ์รังสีและอุปกรณ์การแพทย์ไฟฟ้า",
    "zh-CN": "技术 - 276 辐射和电医疗设备制造",
    "zh-TW": "技術 - 276 輻射和電醫療設備製造",
  },
  "Technology - 277 Manufacture of Optical Instruments and Equipment": {
    de: "Technologie - 277 Herstellung optischer Instrumente und Ausrüstungen",
    it: "Tecnologia - 277 Produzione di strumenti e apparecchiature ottiche",
    ja: "テクノロジー - 277 光学機器・装置の製造",
    ko: "기술 - 277 광학 기기 및 장비 제조",
    th: "เทคโนโลยี - 277 การผลิตเครื่องมือและอุปกรณ์ออปติคัล",
    "zh-CN": "技术 - 277 光学仪器和设备制造",
    "zh-TW": "技術 - 277 光學儀器和設備製造",
  },
  "Forestry & Paper - 152 Manufacture of Containers of Paper and Paperboard": {
    de: "Forstwirtschaft & Papier - 152 Herstellung von Behältern aus Papier und Pappe",
    it: "Silvicoltura e carta - 152 Produzione di contenitori in carta e cartone",
    ja: "林業・紙 - 152 紙・板紙製容器の製造",
    ko: "임업 및 제지 - 152 종이 및 판지 용기 제조",
    th: "ป่าไม้และกระดาษ - 152 การผลิตภาชนะจากกระดาษและกระดาษแข็ง",
    "zh-CN": "林业与造纸 - 152 纸和纸板容器制造",
    "zh-TW": "林業與造紙 - 152 紙和紙板容器製造",
  },
  "Forestry & Paper - 159 Manufacture of Other Paper Products": {
    de: "Forstwirtschaft & Papier - 159 Herstellung sonstiger Papierprodukte",
    it: "Silvicoltura e carta - 159 Produzione di altri prodotti di carta",
    ja: "林業・紙 - 159 その他の紙製品の製造",
    ko: "임업 및 제지 - 159 기타 종이 제품 제조",
    th: "ป่าไม้และกระดาษ - 159 การผลิตผลิตภัณฑ์กระดาษอื่นๆ",
    "zh-CN": "林业与造纸 - 159 其他纸制品制造",
    "zh-TW": "林業與造紙 - 159 其他紙製品製造",
  },
  "Media - 160 Printing and Reproduction of Recorded Media": {
    de: "Medien - 160 Druck und Vervielfältigung von Aufzeichnungsträgern",
    it: "Media - 160 Stampa e riproduzione di supporti registrati",
    ja: "メディア - 160 印刷・録音媒体の複製",
    ko: "미디어 - 160 인쇄 및 기록 매체 복제",
    th: "สื่อ - 160 การพิมพ์และการทำซ้ำสื่อบันทึก",
    "zh-CN": "媒体 - 160 印刷和录制媒体复制",
    "zh-TW": "媒體 - 160 印刷和錄製媒體複製",
  },
  "Oil & Gas - 170 Manufacture of Petroleum and Coal Products": {
    de: "Öl & Gas - 170 Herstellung von Erdöl- und Kohleprodukten",
    it: "Petrolio e gas - 170 Produzione di prodotti petroliferi e carboniferi",
    ja: "石油・ガス - 170 石油・石炭製品の製造",
    ko: "석유 및 가스 - 170 석유 및 석탄 제품 제조",
    th: "น้ำมันและก๊าซ - 170 การผลิตผลิตภัณฑ์ปิโตรเลียมและถ่านหิน",
    "zh-CN": "石油和天然气 - 170 石油和煤炭产品制造",
    "zh-TW": "石油和天然氣 - 170 石油和煤炭產品製造",
  },
  "Chemicals - 181 Manufacture of Raw Chemical Material": {
    de: "Chemie - 181 Herstellung von chemischen Rohstoffen",
    it: "Chimica - 181 Produzione di materie chimiche grezze",
    ja: "化学 - 181 化学原料の製造",
    ko: "화학 - 181 화학 원료 제조",
    th: "เคมี - 181 การผลิตวัตถุดิบเคมี",
    "zh-CN": "化学 - 181 化学原料制造",
    "zh-TW": "化學 - 181 化學原料製造",
  },
  "Chemicals - 183 Manufacture of Fertilizers and Nitrogen Compounds": {
    de: "Chemie - 183 Herstellung von Düngemitteln und Stickstoffverbindungen",
    it: "Chimica - 183 Produzione di fertilizzanti e composti azotati",
    ja: "化学 - 183 肥料・窒素化合物の製造",
    ko: "화학 - 183 비료 및 질소 화합물 제조",
    th: "เคมี - 183 การผลิตปุ๋ยและสารประกอบไนโตรเจน",
    "zh-CN": "化学 - 183 化肥和氮化合物制造",
    "zh-TW": "化學 - 183 化肥和氮化合物製造",
  },
  "Chemicals - 184 Manufacture of Plastic and Synthetic Rubber Materials": {
    de: "Chemie - 184 Herstellung von Kunststoff- und Synthesekautschukmaterialien",
    it: "Chimica - 184 Produzione di materiali plastici e gomma sintetica",
    ja: "化学 - 184 プラスチック・合成ゴム材料の製造",
    ko: "화학 - 184 플라스틱 및 합성 고무 소재 제조",
    th: "เคมี - 184 การผลิตวัสดุพลาสติกและยางสังเคราะห์",
    "zh-CN": "化学 - 184 塑料和合成橡胶材料制造",
    "zh-TW": "化學 - 184 塑料和合成橡膠材料製造",
  },
  "Chemicals - 185 Manufacture of Man-made Fibers": {
    de: "Chemie - 185 Herstellung von Chemiefasern",
    it: "Chimica - 185 Produzione di fibre sintetiche",
    ja: "化学 - 185 化学繊維の製造",
    ko: "화학 - 185 화학 섬유 제조",
    th: "เคมี - 185 การผลิตใยสังเคราะห์",
    "zh-CN": "化学 - 185 人造纤维制造",
    "zh-TW": "化學 - 185 人造纖維製造",
  },
  "Chemicals - 191 Manufacture of Pesticides and Environmental Agents": {
    de: "Chemie - 191 Herstellung von Pestiziden und Umweltmitteln",
    it: "Chimica - 191 Produzione di pesticidi e agenti ambientali",
    ja: "化学 - 191 農薬・環境剤の製造",
    ko: "화학 - 191 살충제 및 환경 약품 제조",
    th: "เคมี - 191 การผลิตยาฆ่าแมลงและสารสิ่งแวดล้อม",
    "zh-CN": "化学 - 191 农药和环保制剂制造",
    "zh-TW": "化學 - 191 農藥和環保製劑製造",
  },
  "Chemicals - 192 Manufacture of Coatings, Dyes and Pigments": {
    de: "Chemie - 192 Herstellung von Farben, Lacken und Pigmenten",
    it: "Chimica - 192 Produzione di rivestimenti, coloranti e pigmenti",
    ja: "化学 - 192 塗料・染料・顔料の製造",
    ko: "화학 - 192 도료, 염료 및 안료 제조",
    th: "เคมี - 192 การผลิตสี สีย้อม และสารสี",
    "zh-CN": "化学 - 192 涂料、染料和颜料制造",
    "zh-TW": "化學 - 192 塗料、染料和顏料製造",
  },
  "Chemicals - 193 Manufacture of Cleaning Preparations": {
    de: "Chemie - 193 Herstellung von Reinigungsmitteln",
    it: "Chimica - 193 Produzione di detergenti",
    ja: "化学 - 193 洗浄剤の製造",
    ko: "화학 - 193 세정제 제조",
    th: "เคมี - 193 การผลิตผลิตภัณฑ์ทำความสะอาด",
    "zh-CN": "化学 - 193 清洁制剂制造",
    "zh-TW": "化學 - 193 清潔製劑製造",
  },
  "Consumer Discretionary Products - 194 Manufacture of Cosmetics": {
    de: "Konsumgüter - 194 Herstellung von Kosmetika",
    it: "Prodotti discrezionali - 194 Produzione di cosmetici",
    ja: "消費財 - 194 化粧品の製造",
    ko: "소비재 - 194 화장품 제조",
    th: "สินค้าผู้บริโภค - 194 การผลิตเครื่องสำอาง",
    "zh-CN": "消费品 - 194 化妆品制造",
    "zh-TW": "消費品 - 194 化妝品製造",
  },
  "Chemicals - 199 Manufacture of Other Chemical Products Not Elsewhere Classified":
    {
      de: "Chemie - 199 Herstellung sonstiger chemischer Erzeugnisse",
      it: "Chimica - 199 Produzione di altri prodotti chimici non classificati",
      ja: "化学 - 199 その他の化学製品の製造",
      ko: "화학 - 199 기타 화학 제품 제조",
      th: "เคมี - 199 การผลิตผลิตภัณฑ์เคมีอื่นๆ",
      "zh-CN": "化学 - 199 其他化学产品制造",
      "zh-TW": "化學 - 199 其他化學產品製造",
    },
  "Biotechnology & Pharma - 200 Manufacture of Pharmaceuticals and Medicinal Chemical Products":
    {
      de: "Biotechnologie & Pharma - 200 Herstellung von Pharmazeutika",
      it: "Biotecnologia e farmaceutica - 200 Produzione di prodotti farmaceutici",
      ja: "バイオテクノロジー・製薬 - 200 医薬品・医療化学品の製造",
      ko: "바이오테크 및 제약 - 200 의약품 및 의료 화학 제품 제조",
      th: "เทคโนโลยีชีวภาพและเภสัชกรรม - 200 การผลิตยาและผลิตภัณฑ์เคมีทางการแพทย์",
      "zh-CN": "生物技术和制药 - 200 药品和医用化学品制造",
      "zh-TW": "生物技術和製藥 - 200 藥品和醫用化學品製造",
    },
  "Industrial - 210 Manufacture of Rubber Products": {
    de: "Industrie - 210 Herstellung von Gummiprodukten",
    it: "Industriale - 210 Produzione di prodotti in gomma",
    ja: "工業 - 210 ゴム製品の製造",
    ko: "산업 - 210 고무 제품 제조",
    th: "อุตสาหกรรม - 210 การผลิตผลิตภัณฑ์ยาง",
    "zh-CN": "工业 - 210 橡胶产品制造",
    "zh-TW": "工業 - 210 橡膠產品製造",
  },
  "Industrial - 220 Manufacture of Plastics Products": {
    de: "Industrie - 220 Herstellung von Kunststoffprodukten",
    it: "Industriale - 220 Produzione di prodotti in plastica",
    ja: "工業 - 220 プラスチック製品の製造",
    ko: "산업 - 220 플라스틱 제품 제조",
    th: "อุตสาหกรรม - 220 การผลิตผลิตภัณฑ์พลาสติก",
    "zh-CN": "工业 - 220 塑料产品制造",
    "zh-TW": "工業 - 220 塑料產品製造",
  },
  "Construction Materials - 231 Manufacture of Glass and Glass Products": {
    de: "Baumaterialien - 231 Herstellung von Glas und Glasprodukten",
    it: "Materiali da costruzione - 231 Produzione di vetro e prodotti in vetro",
    ja: "建築材料 - 231 ガラス・ガラス製品の製造",
    ko: "건설 자재 - 231 유리 및 유리 제품 제조",
    th: "วัสดุก่อสร้าง - 231 การผลิตแก้วและผลิตภัณฑ์แก้ว",
    "zh-CN": "建筑材料 - 231 玻璃及玻璃制品制造",
    "zh-TW": "建築材料 - 231 玻璃及玻璃製品製造",
  },
  "Construction Materials - 232 Manufacture of Refractory Products, Clay Building Materials and Other Porcelain and Ceramic Products":
    {
      de: "Baumaterialien - 232 Herstellung von Feuerfestprodukten und Keramik",
      it: "Materiali da costruzione - 232 Produzione di materiali refrattari e ceramici",
      ja: "建築材料 - 232 耐火製品・陶磁器の製造",
      ko: "건설 자재 - 232 내화 제품, 점토 건축 자재 및 도자기 제조",
      th: "วัสดุก่อสร้าง - 232 การผลิตผลิตภัณฑ์ทนไฟ วัสดุก่อสร้างดินเหนียว และเซรามิก",
      "zh-CN": "建筑材料 - 232 耐火产品、粘土建材及陶瓷制造",
      "zh-TW": "建築材料 - 232 耐火產品、黏土建材及陶瓷製造",
    },
  "Construction Materials - 233 Manufacture of Cement and Cement Products": {
    de: "Baumaterialien - 233 Herstellung von Zement und Zementprodukten",
    it: "Materiali da costruzione - 233 Produzione di cemento e prodotti cementizi",
    ja: "建築材料 - 233 セメント・セメント製品の製造",
    ko: "건설 자재 - 233 시멘트 및 시멘트 제품 제조",
    th: "วัสดุก่อสร้าง - 233 การผลิตปูนซีเมนต์และผลิตภัณฑ์ซีเมนต์",
    "zh-CN": "建筑材料 - 233 水泥及水泥制品制造",
    "zh-TW": "建築材料 - 233 水泥及水泥製品製造",
  },
  "Construction Materials - 234 Cutting, Shaping and Finishing of Stone": {
    de: "Baumaterialien - 234 Schneiden, Formen und Veredeln von Stein",
    it: "Materiali da costruzione - 234 Taglio, sagomatura e finitura della pietra",
    ja: "建築材料 - 234 石材の切断・成形・仕上げ",
    ko: "건설 자재 - 234 석재 절단, 성형 및 마감",
    th: "วัสดุก่อสร้าง - 234 การตัด การขึ้นรูป และการตกแต่งหิน",
    "zh-CN": "建筑材料 - 234 石材切割、成型和精加工",
    "zh-TW": "建築材料 - 234 石材切割、成型和精加工",
  },
  "Construction Materials - 239 Manufacture of Other Non-metallic Mineral Products":
    {
      de: "Baumaterialien - 239 Herstellung sonstiger nichtmetallischer Mineralprodukte",
      it: "Materiali da costruzione - 239 Produzione di altri prodotti minerali non metallici",
      ja: "建築材料 - 239 その他の非金属鉱物製品の製造",
      ko: "건설 자재 - 239 기타 비금속 광물 제품 제조",
      th: "วัสดุก่อสร้าง - 239 การผลิตผลิตภัณฑ์แร่อโลหะอื่นๆ",
      "zh-CN": "建筑材料 - 239 其他非金属矿物产品制造",
      "zh-TW": "建築材料 - 239 其他非金屬礦物產品製造",
    },
  "Metals & Mining - 241 Manufacture of Basic Iron and Steel": {
    de: "Metalle & Bergbau - 241 Herstellung von Roheisen und Stahl",
    it: "Metalli e miniere - 241 Produzione di ghisa e acciaio",
    ja: "金属・鉱業 - 241 鉄鋼の製造",
    ko: "금속 및 광업 - 241 기본 철강 제조",
    th: "โลหะและเหมืองแร่ - 241 การผลิตเหล็กและเหล็กกล้าพื้นฐาน",
    "zh-CN": "金属和采矿 - 241 基本钢铁制造",
    "zh-TW": "金屬和採礦 - 241 基本鋼鐵製造",
  },
  "Metals & Mining - 242 Manufacture of Aluminum": {
    de: "Metalle & Bergbau - 242 Aluminiumherstellung",
    it: "Metalli e miniere - 242 Produzione di alluminio",
    ja: "金属・鉱業 - 242 アルミニウムの製造",
    ko: "금속 및 광업 - 242 알루미늄 제조",
    th: "โลหะและเหมืองแร่ - 242 การผลิตอะลูมิเนียม",
    "zh-CN": "金属和采矿 - 242 铝制造",
    "zh-TW": "金屬和採礦 - 242 鋁製造",
  },
  "Metals & Mining - 243 Manufacture of Copper": {
    de: "Metalle & Bergbau - 243 Kupferherstellung",
    it: "Metalli e miniere - 243 Produzione di rame",
    ja: "金属・鉱業 - 243 銅の製造",
    ko: "금속 및 광업 - 243 구리 제조",
    th: "โลหะและเหมืองแร่ - 243 การผลิตทองแดง",
    "zh-CN": "金属和采矿 - 243 铜制造",
    "zh-TW": "金屬和採礦 - 243 銅製造",
  },
  "Metals & Mining - 249 Manufacture of Other Basic Metals": {
    de: "Metalle & Bergbau - 249 Herstellung sonstiger Basismetalle",
    it: "Metalli e miniere - 249 Produzione di altri metalli di base",
    ja: "金属・鉱業 - 249 その他の基礎金属の製造",
    ko: "금속 및 광업 - 249 기타 기본 금속 제조",
    th: "โลหะและเหมืองแร่ - 249 การผลิตโลหะพื้นฐานอื่นๆ",
    "zh-CN": "金属和采矿 - 249 其他基本金属制造",
    "zh-TW": "金屬和採礦 - 249 其他基本金屬製造",
  },
  "Industrial - 251 Manufacture of Cutlery, Metal Hand Tools and Die": {
    de: "Industrie - 251 Herstellung von Besteck, Metallhandwerkzeug und Gesenken",
    it: "Industriale - 251 Produzione di posate, utensili manuali in metallo e matrici",
    ja: "工業 - 251 刃物・金属手工具・金型の製造",
    ko: "산업 - 251 칼붙이, 금속 수공구 및 금형 제조",
    th: "อุตสาหกรรม - 251 การผลิตมีดและของมีคม เครื่องมือมือโลหะ และแม่พิมพ์",
    "zh-CN": "工业 - 251 刀具、金属手工具和模具制造",
    "zh-TW": "工業 - 251 刀具、金屬手工具和模具製造",
  },
  "Industrial - 252 Manufacture of Metal Structure and Architectural Components":
    {
      de: "Industrie - 252 Herstellung von Metallkonstruktionen und Architekturkomponenten",
      it: "Industriale - 252 Produzione di strutture metalliche e componenti architettonici",
      ja: "工業 - 252 金属構造物・建築部品の製造",
      ko: "산업 - 252 금속 구조물 및 건축 부품 제조",
      th: "อุตสาหกรรม - 252 การผลิตโครงสร้างโลหะและชิ้นส่วนสถาปัตยกรรม",
      "zh-CN": "工业 - 252 金属结构和建筑构件制造",
      "zh-TW": "工業 - 252 金屬結構和建築構件製造",
    },
  "Industrial - 253 Manufacture of Metal Containers": {
    de: "Industrie - 253 Herstellung von Metallbehältern",
    it: "Industriale - 253 Produzione di contenitori metallici",
    ja: "工業 - 253 金属容器の製造",
    ko: "산업 - 253 금속 용기 제조",
    th: "อุตสาหกรรม - 253 การผลิตภาชนะโลหะ",
    "zh-CN": "工业 - 253 金属容器制造",
    "zh-TW": "工業 - 253 金屬容器製造",
  },
  "Industrial - 254 Metalworking Activities": {
    de: "Industrie - 254 Metallbearbeitungsaktivitäten",
    it: "Industriale - 254 Attività di lavorazione dei metalli",
    ja: "工業 - 254 金属加工活動",
    ko: "산업 - 254 금속 가공 활동",
    th: "อุตสาหกรรม - 254 กิจกรรมการแปรรูปโลหะ",
    "zh-CN": "工业 - 254 金属加工活动",
    "zh-TW": "工業 - 254 金屬加工活動",
  },
  "Industrial - 259 Manufacture of Other Fabricated Metal Products": {
    de: "Industrie - 259 Herstellung sonstiger Metallwaren",
    it: "Industriale - 259 Produzione di altri prodotti in metallo lavorato",
    ja: "工業 - 259 その他の金属製品の製造",
    ko: "산업 - 259 기타 금속 가공 제품 제조",
    th: "อุตสาหกรรม - 259 การผลิตผลิตภัณฑ์โลหะแปรรูปอื่นๆ",
    "zh-CN": "工业 - 259 其他金属加工产品制造",
    "zh-TW": "工業 - 259 其他金屬加工產品製造",
  },
  "Industrial - 281 Manufacture of Power Generation, Transmission and Distribution Machinery":
    {
      de: "Industrie - 281 Herstellung von Stromerzeugungsmaschinen",
      it: "Industriale - 281 Produzione di macchinari per generazione, trasmissione e distribuzione di energia",
      ja: "工業 - 281 発電・送配電機械の製造",
      ko: "산업 - 281 발전, 송전 및 배전 기계 제조",
      th: "อุตสาหกรรม - 281 การผลิตเครื่องจักรผลิต ส่ง และกระจายพลังงาน",
      "zh-CN": "工业 - 281 发电、输电和配电机械制造",
      "zh-TW": "工業 - 281 發電、輸電和配電機械製造",
    },
  "Industrial - 282 Manufacture of Batteries and Accumulators": {
    de: "Industrie - 282 Herstellung von Batterien und Akkumulatoren",
    it: "Industriale - 282 Produzione di batterie e accumulatori",
    ja: "工業 - 282 電池・蓄電池の製造",
    ko: "산업 - 282 배터리 및 축전지 제조",
    th: "อุตสาหกรรม - 282 การผลิตแบตเตอรี่และตัวสะสมไฟฟ้า",
    "zh-CN": "工业 - 282 电池和蓄电池制造",
    "zh-TW": "工業 - 282 電池和蓄電池製造",
  },
  "Industrial - 283 Manufacture of Wiring and Wiring Devices": {
    de: "Industrie - 283 Herstellung von Leitungen und Leitungsgeräten",
    it: "Industriale - 283 Produzione di cablaggi e dispositivi di cablaggio",
    ja: "工業 - 283 配線・配線器具の製造",
    ko: "산업 - 283 배선 및 배선 장치 제조",
    th: "อุตสาหกรรม - 283 การผลิตสายไฟและอุปกรณ์สายไฟ",
    "zh-CN": "工业 - 283 布线和布线设备制造",
    "zh-TW": "工業 - 283 佈線和佈線設備製造",
  },
  "Industrial - 284 Manufacture of Lighting Equipment": {
    de: "Industrie - 284 Herstellung von Beleuchtungsgeräten",
    it: "Industriale - 284 Produzione di apparecchiature di illuminazione",
    ja: "工業 - 284 照明器具の製造",
    ko: "산업 - 284 조명 장비 제조",
    th: "อุตสาหกรรม - 284 การผลิตอุปกรณ์ให้แสงสว่าง",
    "zh-CN": "工业 - 284 照明设备制造",
    "zh-TW": "工業 - 284 照明設備製造",
  },
  "Consumer Goods Retail - 285 Manufacture of Domestic Appliances": {
    de: "Konsumgüterhandel - 285 Herstellung von Haushaltsgeräten",
    it: "Beni di consumo - 285 Produzione di elettrodomestici",
    ja: "消費財小売 - 285 家電の製造",
    ko: "소비재 소매 - 285 가전제품 제조",
    th: "สินค้าอุปโภคบริโภค - 285 การผลิตเครื่องใช้ในบ้าน",
    "zh-CN": "消费品零售 - 285 家用电器制造",
    "zh-TW": "消費品零售 - 285 家用電器製造",
  },
  "Industrial - 289 Manufacture of Other Electrical Equipment": {
    de: "Industrie - 289 Herstellung sonstiger Elektrogeräte",
    it: "Industriale - 289 Produzione di altri apparecchiature elettriche",
    ja: "工業 - 289 その他の電気機器の製造",
    ko: "산업 - 289 기타 전기 장비 제조",
    th: "อุตสาหกรรม - 289 การผลิตอุปกรณ์ไฟฟ้าอื่นๆ",
    "zh-CN": "工业 - 289 其他电气设备制造",
    "zh-TW": "工業 - 289 其他電氣設備製造",
  },
  "Industrial - 291 Manufacture of Metalworking Machinery": {
    de: "Industrie - 291 Herstellung von Metallbearbeitungsmaschinen",
    it: "Industriale - 291 Produzione di macchinari per la lavorazione dei metalli",
    ja: "工業 - 291 金属加工機械の製造",
    ko: "산업 - 291 금속 가공 기계 제조",
    th: "อุตสาหกรรม - 291 การผลิตเครื่องจักรแปรรูปโลหะ",
    "zh-CN": "工业 - 291 金属加工机械制造",
    "zh-TW": "工業 - 291 金屬加工機械製造",
  },
  "Industrial - 292 Manufacture of Other Special-purpose Machinery": {
    de: "Industrie - 292 Herstellung sonstiger Spezialmaschinen",
    it: "Industriale - 292 Produzione di altri macchinari per uso speciale",
    ja: "工業 - 292 その他の特殊目的機械の製造",
    ko: "산업 - 292 기타 특수 목적 기계 제조",
    th: "อุตสาหกรรม - 292 การผลิตเครื่องจักรเฉพาะทางอื่นๆ",
    "zh-CN": "工业 - 292 其他专用机械制造",
    "zh-TW": "工業 - 292 其他專用機械製造",
  },
  "Industrial - 293 Manufacture of General-purpose Machinery": {
    de: "Industrie - 293 Herstellung von Allzweckmaschinen",
    it: "Industriale - 293 Produzione di macchinari per uso generale",
    ja: "工業 - 293 汎用機械の製造",
    ko: "산업 - 293 범용 기계 제조",
    th: "อุตสาหกรรม - 293 การผลิตเครื่องจักรทั่วไป",
    "zh-CN": "工业 - 293 通用机械制造",
    "zh-TW": "工業 - 293 通用機械製造",
  },
  "Automobiles - 301 Manufacture of Motor Vehicles": {
    de: "Automobile - 301 Herstellung von Kraftfahrzeugen",
    it: "Automobili - 301 Produzione di autoveicoli",
    ja: "自動車 - 301 自動車の製造",
    ko: "자동차 - 301 자동차 제조",
    th: "ยานยนต์ - 301 การผลิตยานยนต์",
    "zh-CN": "汽车 - 301 机动车辆制造",
    "zh-TW": "汽車 - 301 機動車輛製造",
  },
  "Automobiles - 302 Manufacture of Bodies (Coachwork) for Motor Vehicles": {
    de: "Automobile - 302 Herstellung von Karosserien für Kraftfahrzeuge",
    it: "Automobili - 302 Produzione di carrozzerie per autoveicoli",
    ja: "自動車 - 302 自動車ボディの製造",
    ko: "자동차 - 302 자동차 차체(코치워크) 제조",
    th: "ยานยนต์ - 302 การผลิตตัวถังสำหรับยานยนต์",
    "zh-CN": "汽车 - 302 机动车辆车身制造",
    "zh-TW": "汽車 - 302 機動車輛車身製造",
  },
  "Automobiles - 303 Manufacture of Parts for Motor Vehicles": {
    de: "Automobile - 303 Herstellung von Teilen für Kraftfahrzeuge",
    it: "Automobili - 303 Produzione di parti per autoveicoli",
    ja: "自動車 - 303 自動車部品の製造",
    ko: "자동차 - 303 자동차 부품 제조",
    th: "ยานยนต์ - 303 การผลิตชิ้นส่วนยานยนต์",
    "zh-CN": "汽车 - 303 机动车辆零部件制造",
    "zh-TW": "汽車 - 303 機動車輛零部件製造",
  },
  "Marine Transportation - 311 Manufacture of Ships, Boats and Floating Structures":
    {
      de: "Meeresverkehr - 311 Herstellung von Schiffen und schwimmenden Konstruktionen",
      it: "Trasporto marittimo - 311 Produzione di navi, barche e strutture galleggianti",
      ja: "海上輸送 - 311 船舶・ボート・浮体構造物の製造",
      ko: "해상 운송 - 311 선박, 보트 및 부유 구조물 제조",
      th: "การขนส่งทางทะเล - 311 การผลิตเรือและโครงสร้างลอยน้ำ",
      "zh-CN": "海上运输 - 311 船舶、小船和浮动结构制造",
      "zh-TW": "海上運輸 - 311 船舶、小船和浮動結構製造",
    },
  "Land Transportation - 312 Manufacture of Motorcycles and Parts": {
    de: "Landverkehr - 312 Herstellung von Motorrädern und Teilen",
    it: "Trasporto terrestre - 312 Produzione di motocicli e parti",
    ja: "陸上輸送 - 312 オートバイ・部品の製造",
    ko: "육상 운송 - 312 오토바이 및 부품 제조",
    th: "การขนส่งทางบก - 312 การผลิตรถจักรยานยนต์และชิ้นส่วน",
    "zh-CN": "陆上运输 - 312 摩托车及零部件制造",
    "zh-TW": "陸上運輸 - 312 摩托車及零部件製造",
  },
  "Land Transportation - 313 Manufacture of Bicycles and Parts": {
    de: "Landverkehr - 313 Herstellung von Fahrrädern und Teilen",
    it: "Trasporto terrestre - 313 Produzione di biciclette e parti",
    ja: "陸上輸送 - 313 自転車・部品の製造",
    ko: "육상 운송 - 313 자전거 및 부품 제조",
    th: "การขนส่งทางบก - 313 การผลิตจักรยานและชิ้นส่วน",
    "zh-CN": "陆上运输 - 313 自行车及零部件制造",
    "zh-TW": "陸上運輸 - 313 自行車及零部件製造",
  },
  "Industrial - 319 Manufacture of Other Transport Equipment and Parts Not Elsewhere Classified":
    {
      de: "Industrie - 319 Herstellung sonstiger Transportmittel und Teile",
      it: "Industriale - 319 Produzione di altri mezzi di trasporto e parti non classificati",
      ja: "工業 - 319 その他の輸送機器・部品の製造",
      ko: "산업 - 319 기타 운송 장비 및 부품 제조",
      th: "อุตสาหกรรม - 319 การผลิตอุปกรณ์ขนส่งและชิ้นส่วนอื่นๆ",
      "zh-CN": "工业 - 319 其他运输设备和零部件制造",
      "zh-TW": "工業 - 319 其他運輸設備和零部件製造",
    },
  "Consumer Discretionary Products - 321 Manufacture of Non-metallic Furniture":
    {
      de: "Konsumgüter - 321 Herstellung von nichtmetallischen Möbeln",
      it: "Prodotti discrezionali - 321 Produzione di mobili non metallici",
      ja: "消費財 - 321 非金属家具の製造",
      ko: "소비재 - 321 비금속 가구 제조",
      th: "สินค้าผู้บริโภค - 321 การผลิตเฟอร์นิเจอร์ที่ไม่ใช่โลหะ",
      "zh-CN": "消费品 - 321 非金属家具制造",
      "zh-TW": "消費品 - 321 非金屬家具製造",
    },
  "Consumer Discretionary Products - 322 Manufacture of Metallic Furniture": {
    de: "Konsumgüter - 322 Herstellung von metallischen Möbeln",
    it: "Prodotti discrezionali - 322 Produzione di mobili metallici",
    ja: "消費財 - 322 金属家具の製造",
    ko: "소비재 - 322 금속 가구 제조",
    th: "สินค้าผู้บริโภค - 322 การผลิตเฟอร์นิเจอร์โลหะ",
    "zh-CN": "消费品 - 322 金属家具制造",
    "zh-TW": "消費品 - 322 金屬家具製造",
  },
  "Consumer Discretionary Products - 331 Manufacture of Sports and Recreational Goods":
    {
      de: "Konsumgüter - 331 Herstellung von Sport- und Freizeitartikeln",
      it: "Prodotti discrezionali - 331 Produzione di articoli sportivi e ricreativi",
      ja: "消費財 - 331 スポーツ・レクリエーション用品の製造",
      ko: "소비재 - 331 스포츠 및 레크리에이션 용품 제조",
      th: "สินค้าผู้บริโภค - 331 การผลิตสินค้ากีฬาและสันทนาการ",
      "zh-CN": "消费品 - 331 体育和娱乐用品制造",
      "zh-TW": "消費品 - 331 體育和娛樂用品製造",
    },
  "Health Care Provider - 332 Manufacture of Medical Instruments and Supplies":
    {
      de: "Gesundheitsversorgung - 332 Herstellung von medizinischen Instrumenten",
      it: "Assistenza sanitaria - 332 Produzione di strumenti e forniture mediche",
      ja: "医療 - 332 医療機器・用品の製造",
      ko: "의료 서비스 - 332 의료 기기 및 용품 제조",
      th: "ผู้ให้บริการสุขภาพ - 332 การผลิตเครื่องมือและอุปกรณ์การแพทย์",
      "zh-CN": "医疗保健 - 332 医疗器械和耗材制造",
      "zh-TW": "醫療保健 - 332 醫療器械和耗材製造",
    },
  "Consumer Discretionary Products - 339 Manufacturing Not Elsewhere Classified":
    {
      de: "Konsumgüter - 339 Sonstige Fertigung",
      it: "Prodotti discrezionali - 339 Produzione non classificata altrove",
      ja: "消費財 - 339 その他の製造",
      ko: "소비재 - 339 기타 미분류 제조",
      th: "สินค้าผู้บริโภค - 339 การผลิตที่ไม่ได้จัดประเภท",
      "zh-CN": "消费品 - 339 其他制造业",
      "zh-TW": "消費品 - 339 其他製造業",
    },
  "Air Transportation": {
    de: "Luftverkehr",
    it: "Trasporto aereo",
    ja: "航空輸送",
    ko: "항공 운송",
    th: "การขนส่งทางอากาศ",
    "zh-CN": "航空运输",
    "zh-TW": "航空運輸",
  },
  "Alternative Energy": {
    de: "Alternative Energie",
    it: "Energia alternativa",
    ja: "代替エネルギー",
    ko: "대체 에너지",
    th: "พลังงานทางเลือก",
    "zh-CN": "替代能源",
    "zh-TW": "替代能源",
  },
  "Capital Market": {
    de: "Kapitalmarkt",
    it: "Mercato dei capitali",
    ja: "資本市場",
    ko: "자본 시장",
    th: "ตลาดทุน",
    "zh-CN": "资本市场",
    "zh-TW": "資本市場",
  },
  Coal: {
    de: "Kohle",
    it: "Carbone",
    ja: "石炭",
    ko: "석탄",
    th: "ถ่านหิน",
    "zh-CN": "煤炭",
    "zh-TW": "煤炭",
  },
  "Consumer Services": {
    de: "Verbraucherdienstleistungen",
    it: "Servizi ai consumatori",
    ja: "消費者サービス",
    ko: "소비자 서비스",
    th: "บริการผู้บริโภค",
    "zh-CN": "消费者服务",
    "zh-TW": "消費者服務",
  },
  "Corporate & Retail Banking": {
    de: "Unternehmens- und Privatkundenbank",
    it: "Banca aziendale e al dettaglio",
    ja: "法人・個人銀行",
    ko: "기업 및 소매 금융",
    th: "ธนาคารองค์กรและค้าปลีก",
    "zh-CN": "企业和零售银行",
    "zh-TW": "企業和零售銀行",
  },
  "Food & Beverage Retail": {
    de: "Lebensmittel- und Getränkehandel",
    it: "Commercio al dettaglio di alimenti e bevande",
    ja: "食品・飲料小売",
    ko: "식음료 소매",
    th: "ค้าปลีกอาหารและเครื่องดื่ม",
    "zh-CN": "食品和饮料零售",
    "zh-TW": "食品和飲料零售",
  },
  "Health Care Retail": {
    de: "Gesundheitshandel",
    it: "Commercio al dettaglio sanitario",
    ja: "医療小売",
    ko: "의료 소매",
    th: "ค้าปลีกการดูแลสุขภาพ",
    "zh-CN": "医疗保健零售",
    "zh-TW": "醫療保健零售",
  },
  "Hospitality & Recreation": {
    de: "Gastgewerbe & Freizeit",
    it: "Ospitalità e ricreazione",
    ja: "ホスピタリティ・レクリエーション",
    ko: "숙박 및 레크리에이션",
    th: "การต้อนรับและสันทนาการ",
    "zh-CN": "酒店和娱乐",
    "zh-TW": "酒店和娛樂",
  },
  Infrastructure: {
    de: "Infrastruktur",
    it: "Infrastruttura",
    ja: "インフラ",
    ko: "인프라",
    th: "โครงสร้างพื้นฐาน",
    "zh-CN": "基础设施",
    "zh-TW": "基礎設施",
  },
  "Internet Media & Services": {
    de: "Internet-Medien & Dienste",
    it: "Media e servizi Internet",
    ja: "インターネットメディア・サービス",
    ko: "인터넷 미디어 및 서비스",
    th: "สื่ออินเทอร์เน็ตและบริการ",
    "zh-CN": "互联网媒体和服务",
    "zh-TW": "互聯網媒體和服務",
  },
  "Media Technology": {
    de: "Medientechnologie",
    it: "Tecnologia dei media",
    ja: "メディアテクノロジー",
    ko: "미디어 기술",
    th: "เทคโนโลยีสื่อ",
    "zh-CN": "媒体技术",
    "zh-TW": "媒體技術",
  },
  "Real Estate": {
    de: "Immobilien",
    it: "Immobiliare",
    ja: "不動産",
    ko: "부동산",
    th: "อสังหาริมทรัพย์",
    "zh-CN": "房地产",
    "zh-TW": "房地產",
  },
  Restaurants: {
    de: "Restaurants",
    it: "Ristoranti",
    ja: "レストラン",
    ko: "레스토랑",
    th: "ร้านอาหาร",
    "zh-CN": "餐厅",
    "zh-TW": "餐廳",
  },
  Telecommunications: {
    de: "Telekommunikation",
    it: "Telecomunicazioni",
    ja: "通信",
    ko: "통신",
    th: "โทรคมนาคม",
    "zh-CN": "电信",
    "zh-TW": "電信",
  },
  Utilities: {
    de: "Versorgungsunternehmen",
    it: "Servizi pubblici",
    ja: "公益事業",
    ko: "유틸리티",
    th: "สาธารณูปโภค",
    "zh-CN": "公用事业",
    "zh-TW": "公用事業",
  },
  "Waste Management": {
    de: "Abfallwirtschaft",
    it: "Gestione dei rifiuti",
    ja: "廃棄物管理",
    ko: "폐기물 관리",
    th: "การจัดการของเสีย",
    "zh-CN": "废物管理",
    "zh-TW": "廢物管理",
  },
  Others: {
    de: "Sonstige",
    it: "Altri",
    ja: "その他",
    ko: "기타",
    th: "อื่นๆ",
    "zh-CN": "其他",
    "zh-TW": "其他",
  },
};

export const translateValue = (value, map, language) => {
  if (!value || !language || language === "en") return value;
  return map[value]?.[language] ?? value;
};
